import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { LanguageProvider } from './lib/i18n/LanguageContext';
render(<BrowserRouter data-id="element-675">
    <LanguageProvider data-id="element-676">
      <App data-id="element-677" />
    </LanguageProvider>
  </BrowserRouter>, document.getElementById('root'));